import { compact } from "lodash";
import { baseUrl } from "./baseUrl";
import buildUrl from "../utils/buildUrl";

const ascSortById = "&sort=id%2Casc";

export const getSearchAccRoute = (searchParams, page = 0, size = 10) => {
  const queryString = Object.entries(searchParams)
    .map(([param, value]) => `${param}=${value}`)
    .join("&");
  const query = `pageable-search?${queryString}&page=${page}&size=${size}&${ascSortById}`;
  return [`${baseUrl}`, "accounts-api", "accounts", query].join("/");
};

export const getAccountsRoute = (page) => {
  const query = page !== undefined ? `?page=${page}&size=10&${ascSortById}` : "";
  return compact([`${baseUrl}`, "accounts-api", "accounts", query]).join("/");
};

export const createAccountRoute = () => buildUrl({ url: `${baseUrl}/accounts-api/accounts` });

export const getAccountByIdRoute = (id) =>
  compact([`${baseUrl}`, "accounts-api", "accounts", id]).join("/");

export const getAgreementsByAccIdRoute = (accountId) => {
  const queryString = `search?accountId=${accountId}`;
  return [`${baseUrl}`, "accounts-api", "agreements", queryString].join("/");
};

export const getAgreementsSearchRoute = (searchParams) =>
  buildUrl({
    url: `${baseUrl}/accounts-api/agreements/search`,
    searchParams,
  });

export const getAgreementVersions = (agreementId) =>
  [`${baseUrl}`, "accounts-api", "agreements", agreementId, "versions"].join("/");

export const updateAgreementVersionsRoute = (id, fromDate, force) =>
  [
    `${baseUrl}`,
    "/accounts-api",
    "/agreements",
    `/${id}`,
    `?fromDate=${encodeURIComponent(fromDate)}`,
    `&force=${force}`,
  ].join("");

export const deleteAgreementVersionsRoute = (id, fromDate) =>
  [
    `${baseUrl}`,
    "/accounts-api",
    "/agreements",
    `/${id}`,
    `?fromDate=${encodeURIComponent(fromDate)}`,
  ].join("");

export const getAgreementByAgrId = (id) =>
  [`${baseUrl}`, "accounts-api", "agreements", id].join("/");

export const createAgreementByAccId = (id) =>
  [`${baseUrl}`, "accounts-api", "accounts", id, "agreements"].join("/");

export const getEmailsByAccountId = (accountId) =>
  [`${baseUrl}`, "accounts-api", "accounts", accountId, "billDeliveryEmails"].join("/");

export const getAccountPageableSearchRoute = () =>
  [`${baseUrl}`, "accounts-api", "accounts", `pageable-search`].join("/");

export const getClientSearchRoute = (searchParam, searchItem, page = 0, itemsPerPage = 20) => {
  const encodedSearchItem = encodeURIComponent(searchItem);
  const query = `pageable-search?${searchParam}=${encodedSearchItem}&page=${page}&size=${itemsPerPage}`;
  return [`${baseUrl}`, "accounts-api", "accounts", query].join("/");
};

export const getAccountSelectSearchRoute = (searchItem, page = 0, itemsPerPage = 20) => {
  const encodedSearchItem = encodeURIComponent(searchItem);
  const query = `pageable-search?organization.fullName=${encodedSearchItem}&page=${page}&size=${itemsPerPage}`;
  return [`${baseUrl}`, "accounts-api", "accounts", query].join("/");
};

export const getCreateSubscriberVersionRoute = (subscriberId, fromDate) =>
  [`${baseUrl}`, "accounts-api", "subscribers", `${subscriberId}?fromDate=${fromDate}`].join("/");

export const getCreateOrganizationVersionRoute = (orgId, fromDate, force = false) =>
  [
    `${baseUrl}`,
    "accounts-api",
    "organizations",
    `${orgId}?fromDate=${encodeURIComponent(fromDate)}&force=${force}`,
  ].join("/");

export const getAccountVersionsRoute = (accId) =>
  [`${baseUrl}`, "accounts-api", "accounts", `${accId}`, "versions"].join("/");

export const getAddressesByAddressIdRoute = (addressId) =>
  [`${baseUrl}`, "accounts-api", "addresses", `${addressId}`].join("/");

export const getAddressesVersionsRoute = (accId) =>
  [`${baseUrl}`, "accounts-api", "addresses", `${accId}`, "versions"].join("/");

export const getAccountEmailsRoute = (accId) =>
  [`${baseUrl}`, "accounts-api", "accounts", accId, "billDeliveryEmails"].join("/");

export const getSubscribersRoute = () => [`${baseUrl}`, "accounts-api", "subscribers"].join("/");

export const getEditAddressesVersionsRoute = (accId, fromDate, force = false) =>
  [
    `${baseUrl}`,
    "accounts-api",
    "addresses",
    `${accId}?fromDate=${encodeURIComponent(fromDate)}&force=${force}`,
  ].join("/");

// TODO переименовать, т.к используется и для удаления
export const getEditAccountVersionsRoute = (accId, fromDate) =>
  [
    `${baseUrl}`,
    "accounts-api",
    "accounts",
    `${accId}?fromDate=${encodeURIComponent(fromDate)}`,
  ].join("/");

// TODO переименовать, т.к используется и для удаления
export const getCreateEmailVersionRoute = (emailId, fromDate, force = false) =>
  [
    `${baseUrl}`,
    "accounts-api",
    "contact-emails",
    `${emailId}?fromDate=${fromDate}&force=${force}`,
  ].join("/");

export const getOrganizationVersionsRoute = (orgId) =>
  [`${baseUrl}`, "accounts-api", "organizations", `${orgId}`, "versions"].join("/");

export const getOrganizationRoute = (orgId) =>
  [`${baseUrl}`, "accounts-api", "organizations", `${orgId}`].join("/");

export const getAccountSubscribersRoute = (accId) =>
  [`${baseUrl}`, "accounts-api", "subscribers", `search?accountId=${accId}`].join("/");

export const getCreateAccountEmailsRoute = (accId, fromDate) =>
  [
    `${baseUrl}`,
    "accounts-api",
    "accounts",
    accId,
    `billDeliveryEmails?fromDate=${encodeURIComponent(fromDate)}`,
  ].join("/");

export const getAccountEmailVersionsRoute = (emailId) =>
  [`${baseUrl}`, "accounts-api", "contact-emails", emailId, "versions"].join("/");

export const getUpdateAccountRoute = (accId, fromDate) =>
  [
    `${baseUrl}`,
    "accounts-api",
    "accounts",
    `${accId}?fromDate=${encodeURIComponent(fromDate)}`,
  ].join("/");

export const getIndividualDocumentRoute = ({ documentId }) =>
  buildUrl({ url: `${baseUrl}/accounts-api/identity-documents/${documentId}` });
